import PropTypes from "prop-types";

import { bannerHeaderTextCss } from "./BannerHeaderText.style";

const propTypes = {
  title: PropTypes.string.isRequired,
};

const BannerHeaderText = ({ title }) => (
  <p css={bannerHeaderTextCss}>{title}</p>
);

BannerHeaderText.propTypes = propTypes;
export default BannerHeaderText;
